import { render, staticRenderFns } from "./subproperty-list-page.vue?vue&type=template&id=1326f83a&scoped=true&"
import script from "./subproperty-list-page.vue?vue&type=script&lang=js&"
export * from "./subproperty-list-page.vue?vue&type=script&lang=js&"
import style0 from "./subproperty-list-page.vue?vue&type=style&index=0&id=1326f83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1326f83a",
  null
  
)

export default component.exports